module.exports = __webpack_public_path__ + "static/img/favicon.352e47f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.png
// module id = 1H3f
// module chunks = 0